import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Collapse } from '@material-ui/core';
import ExpandMore from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import Message from '../message/Message.js';
import useIsMobile from '../../../hooks/useIsMobile';

const useStyles = makeStyles(theme => ({
    root: {
        '& .MuiAlert-message': {
            flexGrow: 1
        }
    },
    list: {
        margin: theme.spacing(1, 0, 0, 2.5),
        padding: 0,
        listStyleType: 'disc'
    },
    listItem: {
        margin: theme.spacing(0.5, 0)
    },
    headerCollapsible: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        userSelect: 'none',
        width: '100%'
    },
    headerNormal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
    },
    title: {
        flexGrow: 1
    },
    icon: {
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        transform: 'rotate(0deg)'
    },
    iconExpanded: {
        transform: 'rotate(180deg)'
    }
}));

export default function InstructionMessage(props) {
    const {
        title,
        items = [],
        type = 'info',
        variant = 'standard',
        className = '',
        listType = 'ordered',
        collapsible = false,
        defaultExpanded = false,
        marginBottom = true
    } = props;

    const classes = useStyles();
    const isMobile = useIsMobile();
    const mobileCollapsible = isMobile || collapsible;
    const [expanded, setExpanded] = React.useState(() => !isMobile && defaultExpanded);
    const ListTag = listType === 'ordered' ? 'ol' : 'ul';

    React.useEffect(() => {
        if (isMobile) setExpanded(false);
    }, [isMobile]);

    const handleToggle = () => {
        if (mobileCollapsible) {
            setExpanded(prev => !prev);
        }
    };

    const headerClass = mobileCollapsible ? classes.headerCollapsible : classes.headerNormal;

    return (
        <div className={className || classes.root}>
            <Message type={type} variant={variant} marginBottom={marginBottom}>
                <div className={headerClass} onClick={handleToggle}>
                    {title && <strong className={classes.title}>{title}</strong>}
                    {mobileCollapsible && (
                        <ExpandMore
                            className={clsx(classes.icon, {
                                [classes.iconExpanded]: expanded
                            })}
                        />
                    )}
                </div>
                {items.length > 0 && (
                    mobileCollapsible ? (
                        <Collapse in={expanded}>
                            <ListTag className={classes.list}>
                                {items.map((item, idx) => (
                                    <li key={idx} className={classes.listItem}>
                                        {item}
                                    </li>
                                ))}
                            </ListTag>
                        </Collapse>
                    ) : (
                        <ListTag className={classes.list}>
                            {items.map((item, idx) => (
                                <li key={idx} className={classes.listItem}>
                                    {item}
                                </li>
                            ))}
                        </ListTag>
                    )
                )}
            </Message>
        </div>
    );
}

InstructionMessage.propTypes = {
    title: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.string).isRequired,
    type: PropTypes.oneOf(['error', 'info', 'success', 'warning', 'waiting', 'blank']),
    variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
    className: PropTypes.string,
    listType: PropTypes.oneOf(['ordered', 'unordered']),
    collapsible: PropTypes.bool,
    defaultExpanded: PropTypes.bool,
    /* Espaçamento padrão abaixo da mensagem; desligue só quando o container já cuidar disso. */
    marginBottom: PropTypes.bool
};

